import { styled } from '@material-ui/core'

export const TextStandard = styled('div')(({ theme }) => ({
  fontSize: '14px',
  lineHeight: '120%',
  fontWeight: 'normal',
  color: theme.palette.text.primary,
}))
